const phoneRegExp = /^\d{3}-\d{3}-\d{4}?$/;

/**
 * Return a masked phone number as ###-###-#### (without the 1 prefix) and the
 * relative cursor position.
 */
export function maskPhone(
  /** The value that should be masked as phone number. */
  value: string | number,
  /** The cursor position before the masking. */
  cursorPosition = 0
): [masked: string, cursorPosition: number] {
  const noPrefix = String(value).replace(/^1/, ''); // Remove "1" prefix
  let masked = noPrefix;
  let newCursorPosition = cursorPosition;

  if (phoneRegExp.exec(masked)) {
    // Code is already masked, do nothing
    return [masked, newCursorPosition];
  }

  const onlyNumbers = masked.replace(/\D/g, '');
  const firstBlock = onlyNumbers.substring(0, 3);
  const secondBlock = onlyNumbers.substring(3, 6);
  const thirdBlock = onlyNumbers.substring(6, 10);
  const nOfDashes = noPrefix.split('-').length - 1;

  if (thirdBlock) {
    masked = `${firstBlock}-${secondBlock}-${thirdBlock}`;
  } else if (secondBlock) {
    masked = `${firstBlock}-${secondBlock}`;
    if (secondBlock.length === 3) {
      masked = `${masked}-`;
    }
  } else {
    masked = onlyNumbers;
    if (firstBlock.length === 3) {
      masked = `${masked}-`;
    }
  }

  // Calculate the new cursor position
  if (thirdBlock) {
    if (nOfDashes === 0 && cursorPosition > 3) {
      if (cursorPosition > 6) {
        newCursorPosition = cursorPosition + 2;
      } else {
        newCursorPosition = cursorPosition + 1;
      }
    }
    if (nOfDashes === 1 && cursorPosition > 6) {
      newCursorPosition = cursorPosition + 1;
    }
  } else if (secondBlock) {
    if (nOfDashes === 0 && cursorPosition > 3) {
      newCursorPosition = cursorPosition + 1;
    }
    if (nOfDashes === 1 && cursorPosition > 3) {
      newCursorPosition = cursorPosition + 2;
    }
    if (nOfDashes === 2 && cursorPosition === 3) {
      newCursorPosition = cursorPosition + 2;
    }
  } else {
    if (nOfDashes === 0 && firstBlock.length === 3) {
      newCursorPosition = cursorPosition + 1;
    }
  }
  return [masked, newCursorPosition];
}

const clearRegExp = /-$/;
/** Function to cleanup the phone mask while typing backspace */
export function cleanPhoneMask(value: string): string {
  let maskedValue = value;
  if (clearRegExp.exec(value)) {
    maskedValue = value.replace(clearRegExp, '');
  }
  return maskedValue;
}
